import { useTranslation } from 'react-i18next';
import { Box, KeyValue, Pill } from 'web-library';
import React from 'react';
import FormHeader from '../../../components/form-items/FormHeader';
import { useStyles } from './index';

interface ManageAccountContentProps {
  userType: string;
  accountType: string;
  activeStatus: string;
  lockStatus: string;
  blockStatus: string;
  expiredStatus?: string;
  roles?: { id: number; displayName: string }[];
}

const ManageAccountContent = ({
  userType,
  accountType,
  activeStatus,
  lockStatus,
  blockStatus,
  expiredStatus,
  roles,
}: ManageAccountContentProps) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  return (
    <>
      <FormHeader
        containerClassName={classes.formHeader}
        title={t('admin->>UserAccountManagement.ManageAccount')}
      />
      <Box className={classes.responsiveFlexContainer}>
        <Box className={classes.formElementContainer}>
          <KeyValue keyText={t('admin->>UserAccountManagement.UserType')} valueText={userType} />
        </Box>
        <Box className={classes.formElementContainer}>
          <KeyValue
            keyText={t('admin->>UserAccountManagement.AccountType')}
            valueText={accountType}
          />
        </Box>
        <Box
          className={
            expiredStatus
              ? [classes.halfWidthLeftItem, classes.statusContainer].join(' ')
              : classes.formElementContainer
          }
        >
          <KeyValue
            keyText={t('admin->>UserAccountManagement.ActiveStatus')}
            valueText={
              <Pill
                variant={activeStatus === 'ACTIVE' ? 'positive' : 'negative'}
                label={
                  activeStatus === 'ACTIVE'
                    ? t('admin->>AdminAccountManagement.Activated')
                    : t('admin->>AdminAccountManagement.NotActivated')
                }
              />
            }
          />
        </Box>
        {expiredStatus && (
          <Box className={[classes.halfWidthRightItem, classes.statusContainer].join(' ')}>
            <KeyValue
              keyText={t('admin->>UserAccountManagement.ExpiredStatus')}
              valueText={
                <Pill
                    variant={expiredStatus === 'EXPIRED' ? 'negative' : 'info'}
                    label={expiredStatus === 'EXPIRED' ?
                        t('admin->>AdminAccountManagement.Expired')
                        : t('admin->>AdminAccountManagement.NotExpired')}
                />
              }
            />
          </Box>
        )}
        <Box className={[classes.halfWidthLeftItem, classes.statusContainer].join(' ')}>
          <KeyValue
            keyText={t('admin->>UserAccountManagement.LockStatus')}
            valueText={
              <Pill
                variant={lockStatus === 'LOCKED' ? 'negative' : 'info'}
                label={
                  lockStatus === 'LOCKED'
                    ? t('admin->>AdminAccountManagement.Locked')
                    : t('admin->>AdminAccountManagement.NotLocked')
                }
              />
            }
          />
        </Box>
        <Box className={[classes.halfWidthRightItem, classes.statusContainer].join(' ')}>
          <KeyValue
            keyText={t('admin->>UserAccountManagement.BlockStatus')}
            valueText={
              <Pill
                variant={blockStatus === 'NOT BLOCKED' ? 'info' : 'negative'}
                label={
                  blockStatus === 'NOT BLOCKED'
                    ? t('admin->>AdminAccountManagement.NotBlocked')
                    : t('admin->>AmindAccountManagement.Blocked')
                }
              />
            }
          />
        </Box>
        <Box className={classes.formElementContainer}>
          <KeyValue
            keyText={t('admin->>UserAccountManagement.UserGroups')}
            valueText={roles ? roles.map((role) => role.displayName).join(', ') : '-'}
            capitalize={false}
          />
        </Box>
      </Box>
    </>
  );
};

export default ManageAccountContent;
